
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import Icon from 'vux/src/components/icon/index.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'

import { mapGetters } from "vuex";

export default {
computed: {

headShow() {
return this.$store.getters.headShow;
},
loading() {
return this.$store.getters.loading;
},
footerShow() {
return this.$store.getters.footerShow;
},
pageTitle() {
return "个人积分";
},
},
components: {
Tabbar,
TabbarItem,
XHeader,
Loading,
ViewBox,
Icon,
},
data() {
return {
myIndex: 111,
mingci: 1000,
jifen: 100,
name: "无权限",
icOne: require("@/assets/images/icons/ic_one.png"),
icTwo: require("@/assets/images/icons/ic_two.png"),
icThree: require("@/assets/images/icons/ic_three.png"),
show: false,
datas: [],
};
},
mounted() {
this.$store.commit("UPDATE_PAGE_TITLE", "任务提交");
this.showPicker = this.$route.params.titles;
this.value2 = this.$route.params.id;


},

created() {
console.log("预加载");
this.getall();

this.getCode2();


},

computed: {

} ,
methods: {

getcode(code) {
this.$axios
.get(this.$httpUrl + "/daren/darennewuser/getopenid?code=" + code)
.then((res) => res.data)
.then((res) => {
console.log(res);



localStorage.setItem("wxid", res.openid);

console.log(res.openid);


this.getgrbywxid(res.openid);
});
},
getCode2() {

const code = this.getUrlCode("code"); 
const local = window.location.href;
const appid = "wx42c6d3b85f7597bb";
if (code == null || code === "") {
console.log("进入微信跳转");
window.location.href =
"https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx42c6d3b85f7597bb&redirect_uri=http://www.qlslj.cn/studyRanking&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
} else {
this.getcode(code); 
}
},


getUrlCode(name) {

var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");

var r = window.location.search.substr(1).match(reg);
if (r != null) {
return unescape(r[2]);
} else {
return null;
}
},

getall() {
this.$axios
.get(this.$httpUrl + "/daren/point/list?pageSize=1000&pageNum=1")
.then((res) => res.data)
.then((res) => {
console.log(res);
this.datas = res.rows;
});
},
getgrbywxid(wxid) {


this.$axios
.get(this.$httpUrl + "/daren/point/queryByWxid?wxid=" + wxid)
.then((res) => res.data)
.then((res) => {
console.log(res);

if (res.result != "ok") {

this.show = true;
} else {

console.log(res.user_info);
console.log(res.user_info.name);

this.name = res.user_info.name;

this.jifen = res.user_info.point;

this.mingci = res.rank;
}

});
},

getImg(index) {
if (index == 0) {
return this.icOne;
} else if (index == 1) {
return this.icTwo;
} else if (index == 2) {
return this.icThree;
}
},


getphone(number) {
const masked = number.replace(/(\d{3})\d{4}(\d{3})/, '$1****$2');
return masked;

},
},
};



// WEBPACK FOOTER //
// ./src/views/studyRanking.vue